export default __webpack_public_path__ + "static/media/end-of-life.b42dce45.png";